'use client';

import { EnergySourceIcon } from '../atomic/EnergySourceIcon';

interface InstallationItemProps {
  name: string;
  type: 'solar' | 'water' | 'biomass' | 'biogas';
  capacity: number;
  yearlyProduction: number;
  isLast?: boolean;
}

// Named export for better tree-shaking and explicit imports
export function InstallationItem({
  name,
  type,
  capacity,
  yearlyProduction,
  isLast = false
}: InstallationItemProps) {
  // Format capacity with unit (kWp for solar, kW for others)
  const capacityUnit = type === 'solar' ? 'kWp' : 'kW';
  const formattedCapacity = `${capacity.toLocaleString('de-AT')} ${capacityUnit}`;
  
  // Format yearly production
  const formattedProduction = (yearlyProduction / 1000).toLocaleString('de-AT', {
    maximumFractionDigits: 1
  }) + ' MWh';

  return (
    <div className={`flex items-center justify-between py-3 ${!isLast ? 'border-b border-gray-200 dark:border-gray-700' : ''}`}>
      <div className="flex items-center">
        <EnergySourceIcon type={type} size={20} className="mr-3 flex-shrink-0" />
        <div>
          <div className="font-medium text-gray-900 dark:text-white">{name}</div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            {formattedCapacity}
          </div>
        </div>
      </div>
      <div className="text-right">
        <div className="font-medium text-gray-900 dark:text-white">{formattedProduction}</div>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          {yearlyProduction.toLocaleString('de-AT')} kWh
        </div>
      </div>
    </div>
  );
}
